/**
 * 
 */

function appScreenActive(data){
	if(window.mub){
		window.mub.inc = data;
	}
}

window.przAppMobile = window.przAppMobile || {
	os: null,
	 
	getOs: function() {
		if(this.os !== null){
			return this.os;
		}
		 
		if (typeof native !== 'undefined' && typeof native.setCartItem === 'function') {
		    return this.os = 'android';
		}
		
		if (typeof webkit !== 'undefined' && typeof webkit.messageHandlers==='object' && webkit.messageHandlers.hasOwnProperty('setCartItem') && typeof webkit.messageHandlers.setCartItem.postMessage === 'function') {
		    return this.os = 'ios';
		}
		
		return this.os = '';
	},
	 
	isIOs: function() {
		return this.getOs() === 'ios';
	},
	 
	isAndroid: function() {
		return this.getOs() === 'android';
	},
	 
	call: function(option, value){
		if(document && document.location.hostname.indexOf('prozis.com') === -1){
			console.log('App mobile event: '+option, value);
		}
		
		var os = this.getOs();
		if(os === ''){
			// unable to find out OS...
		    return ;
		}

		switch(option) {
		    case 'setCartItem':
		        // force integer
		        return this._call(os, option, parseInt(value));
		        
		    case 'genericEvent':
				// change event name to 'genericEventAcknowledgement'
				return this._call(os, 'genericEventAcknowledgement', value);
				
		    case 'CheckoutPosition':
				this._call(os, 'checkoutPosition', value);
				
		        var b = document.getElementById('beachBall');
		        if(b){b.style.display='none';}
		        b = document.getElementById('beach-ball');
		        if(b){b.style.display='none';}
		        
		        return false;
		        
		    case 'openModal':
		        var to_send = JSON.stringify( { name: value.name, endpoint: value.url } );
				return this._call(os, option, to_send);
		        
		    case 'changeStore':
				// tricky 
				if(os === 'android'){
		            var store_lang = value.split(',');
		            option = store_lang[0];
		            value = store_lang[1];
				}
		        return this._call(os, option, value);
		        
		    case 'changeStoreV1_3':
				// tricky 
		        switch (appSys) {
		            case 'android':
		                var store_lang = value.split(',');
		                var customerId = (typeof store_lang[2] === 'undefined' ? null : store_lang[2]);
		                native.changeStore(store_lang[0], store_lang[1], customerId);
		                break
		            case 'ios':
		                webkit.messageHandlers.changeStore.postMessage(value);
		                break
		        }
		        return false;
		        
		    case 'changeStoreV1_5':
				// change event name to 'changeStore'
				return this._call(os, 'changeStore', value);
				
		    case 'openTab':
				// check if function exists (maybe because backward compatibility)
		        var function_check = false;
		        if (typeof native !== 'undefined' && typeof native.openTab === 'function') {
		            function_check = true;
		        }
		        if (typeof webkit !== 'undefined' && typeof webkit.messageHandlers==='object' && webkit.messageHandlers.hasOwnProperty('openTab')) {
		            function_check = true;
		        }
		        
		        if(function_check) {
		            var to_send = JSON.stringify( { name: value.name } );
		            return this._call(os, option, to_send);
		        } 
		        else {
		            window.location = value.url_fail;
		        }
		        return false;
		        
		    case 'showVideo':
		    case 'orderCanceled':
		    case 'ClearUrlNoResults':
		    case 'setUser':
		    case 'userAuthChange':
		    case 'dataGoogleAnalytics':
		    case 'barcodeSearchSucceeded': 
		    case 'updateLike':
		    case 'currentPage':
		    case 'cannotComment':
		    case 'evtModal':
		    case 'evtNativeModalClose':
		    case 'openNativeScreen':
		    case 'page':
		    case 'goBack':
			case 'closeCheckout':
			case 'navigation':
			case 'shareContent':
				return this._call(os, option, value);
			default:
				console.log('Unknown event: '+option);
				break;	
		}		 
	},
	 
	_call: function(os, option, value){
		if(os === 'android'){
			if(native.hasOwnProperty(option) && typeof native[option] === 'function'){
				native[option](value);
			}
			else{
				console.error('Unknown function: '+option);
			}
		}
		else if(os === 'ios'){
			if(typeof webkit !== 'undefined' && webkit.messageHandlers.hasOwnProperty(option)){
			 	webkit.messageHandlers[option].postMessage(value);
			}
			 else{
				console.error('Unknown function: '+option);
			}
		}
		// return false because action may be triggered from "href"
		return false;
	}
};